import { render } from "./Spo2Read.vue?vue&type=template&id=0852935a"
import script from "./Spo2Read.vue?vue&type=script&lang=js"
export * from "./Spo2Read.vue?vue&type=script&lang=js"

import "./Spo2Read.vue?vue&type=style&index=0&id=0852935a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__